import axios from "axios";
class ApiGlossary {
    static async GetGlossary(session_uuid) {
        try {
            const result = await axios.get("/api/admin/glossary/list", {
                headers: {
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            throw new Error("Error get glossary");
        }
    }
    static BuildBody(payload) {
        return {
            term: payload.term,
            definition: payload.definition,
            is_advanced: payload.is_advanced ? 1 : 0,
            letter: payload.letter || "",
            url: payload.url || "",
            seo_title: payload.seo_title || "",
            seo_description: payload.seo_description || "",
            long_definition: payload.long_definition || "",
            related_links: Array.isArray(payload.related_links) ? payload.related_links : [],
        };
    }
    static async CreateTerm(session_uuid, payload) {
        try {
            const result = await axios.post("/api/admin/glossary/create", ApiGlossary.BuildBody(payload), {
                headers: {
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async UpdateTerm(session_uuid, payload) {
        try {
            const result = await axios.post("/api/admin/glossary/update", {
                uuid: payload.uuid,
                ...ApiGlossary.BuildBody(payload),
            }, {
                headers: {
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async DeleteTerm(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/glossary/delete", {
                uuid: uuid,
            }, {
                headers: {
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async ToggleVisibility(session_uuid, uuid, is_visible) {
        try {
            const result = await axios.post("/api/admin/glossary/toggle-visibility", {
                uuid: uuid,
                is_visible: is_visible,
            }, {
                headers: {
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
}
export default ApiGlossary;
